import React, { useState } from 'react';
import '../css/TeamPage.css';
import Divyashil from '../Images/Divyashil.png'
import Ishita from '../Images/Ishita.png'
import Sushrut from '../Images/Sushrut.png'
import Swarupa from '../Images/Swarupa.png'

const teamMembers = [
  {
    name: 'Divyashil Agale',
    title: 'Founder & CEO',
    description:
      'Visionary leader driving the core mission of Red Fibre — to empower creators through innovative digital tools and personalized branding experiences.',
    image: Divyashil
  },
    {
    name: 'Ishita Thakur',
    title: 'Head of Operations',
    description:
      'Oversees day-to-day business processes and ensures operational excellence across all digital touchpoints and customer journeys.',
    image: Ishita
  },
  {
    name: 'Sushrut Nagula',
    title: 'Head of Management',
    description:
      'Responsible for aligning cross-functional teams and ensuring seamless execution across strategy, operations, and project delivery.',
    image: Sushrut
  },
  {
    name: 'Swarupa Kulkarni',
    title: 'Research Development Head',
    description:
      'Leads innovation, R&D efforts, and product evolution — translating user needs and future trends into breakthrough solutions.',
    image: Swarupa
  },
];

const TeamMemberCard = ({ member }) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  return (
    <div className="tp-team-card">
      <div className="tp-team-image-container">
        {!imageLoaded && !imageError && (
          <div className="tp-image-placeholder">
            <div className="tp-loading-spinner"></div>
          </div>
        )}
        <img
          src={imageError ? '/images/placeholder.png' : member.image}
          alt={member.name}
          className={`tp-team-image ${imageLoaded ? 'tp-loaded' : ''}`}
          onError={handleImageError}
          onLoad={handleImageLoad}
          style={{ display: imageLoaded || imageError ? 'block' : 'none' }}
        />
      </div>
      <h3 className="tp-team-name">{member.name}</h3>
      <p className="tp-team-title">{member.title}</p>
      <p className="tp-team-description">{member.description}</p>
    </div>
  );
};

const TeamPage = () => {
  return (
    <div className="tp-team-container">
      <h1 className="tp-team-heading">Meet Our Core Team</h1>
      <p className="tp-team-subheading">The minds behind Red Fibre's innovation and impact</p>
      <div className="tp-team-grid">
        {teamMembers.map((member, index) => (
          <TeamMemberCard key={index} member={member} />
        ))}
      </div>
    </div>
  );
};

export default TeamPage;